<template>
  <v-list-item :value="value" :disabled="disabled" @click="handleClick()" nav>
    <v-list-item-avatar v-if="currentBreakpoint > 0">
      <v-icon centered> {{ icon }} </v-icon>
    </v-list-item-avatar>

    <v-list-item-content>
      <v-list-item-title v-if="currentBreakpoint > 0">
        {{ label }}
      </v-list-item-title>
      <v-list-item-title v-else class="text-center">
        <v-icon centered> {{ icon }} </v-icon>
      </v-list-item-title>
      <v-list-item-subtitle v-if="currentBreakpoint > 1"><div v-html="subLabel" /></v-list-item-subtitle>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
import Responsive from '@/mixins/responsive';

export default {
  name: 'NavigationItem',

  emits: ['onClick'],

  mixins: [Responsive],

  props: {
    label: String,
    subLabel: String,
    icon: String,
    value: String,
    disabled: Boolean,
  },

  methods: {
    handleClick() {
      this.$emit('onClick', this.value);
    },
  },
};
</script>

<style></style>
